
import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { PropositionStatus} from './master-proposal.model';
import 'rxjs/add/operator/map';

/**
 *
 * MasterProposalLineService
 */
@Injectable()
export class MasterProposalLineService {

    private resourceInterneUrl = 'api/interne/master-proposals';

    constructor(private http: Http) {
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceInterneUrl, options).map((res: any) => this.convertResponse(res));
    }
    count(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        let params: URLSearchParams = new URLSearchParams();
        params.set('campaign', req.campaign);
        options.search = params;
        return this.http.get(this.resourceInterneUrl + '/count', options);
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('campaign', req.campaign);
            params.set('query', req.query);
            if (req.filters && req.filters.reference && req.filters.reference.value ) {
                params.set('reference', req.filters.reference.value);
            }
            if (req.filters && req.filters.studentName && req.filters.studentName.value ) {
                params.set('studentName', req.filters.studentName.value);
            }
            if (req.filters && req.filters.licenceTitle && req.filters.licenceTitle.value ) {
                params.set('licenceTitle', req.filters.licenceTitle.value);
            }
            if (req.filters && req.filters.licenceAcademyLabel && req.filters.licenceAcademyLabel.value ) {
                params.set('licenceAcademyLabel', req.filters.licenceAcademyLabel.value);
            }
            if (req.filters && req.filters.licenceAcademicRegionLabel && req.filters.licenceAcademicRegionLabel.value ) {
                params.set('licenceAcademicRegionLabel', req.filters.licenceAcademicRegionLabel.value);
            }
            if (req.filters && req.filters.masterInm && req.filters.masterInm.value ) {
                params.set('masterInm', req.filters.masterInm.value);
            }
            if (req.filters && req.filters.formationLabel && req.filters.formationLabel.value ) {
                params.set('formationLabel', req.filters.formationLabel.value);
            }
            if (req.filters && req.filters.masterSchoolName && req.filters.masterSchoolName.value ) {
                params.set('masterSchoolName', req.filters.masterSchoolName.value);
            }
            if (req.filters && req.filters.status && req.filters.status.value ) {
                params.set('status', req.filters.status.value.map(v => PropositionStatus[v]));
            }
            if (req.filters && req.filters.academyLabel && req.filters.academyLabel.value ) {
                params.set('academyLabel', req.filters.academyLabel.value);
            }
            if (req.filters && req.filters.academicRegionLabel && req.filters.academicRegionLabel.value ) {
                params.set('academicRegionLabel', req.filters.academicRegionLabel.value);
            }
            if (req.filters && req.filters.masterSchoolUai && req.filters.masterSchoolUai.value ) {
                params.set('masterSchoolUai', req.filters.masterSchoolUai.value);
            }
            if (req.first) {
                params.set('_first', req.first);
            }
            if (req.rows) {
                params.set('_rows', req.rows);
            }
            if (req.multiSortMeta) {
                params.set('_sort', req.multiSortMeta.map(sort => sort.field + (sort.order === 1 ? ' asc' : ' desc')).join(','));
                params.set('_sort', params.get('_sort').replace(/formationLabel ([a-z]+)/, 'masterLabel $1,specialityLabel $1'));
            }
            options.search = params;
        }
        return options;
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].formationLabel = jsonResponse[i].masterLabel;
            if (jsonResponse[i].specialityLabel) {
                jsonResponse[i].formationLabel += ' - ' + jsonResponse[i].specialityLabel;
            }

            if (jsonResponse[i].status != null) {
                jsonResponse[i].status = PropositionStatus[jsonResponse[i].status + ''];
            }
        }
        res._body = jsonResponse;
        return res;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master-proposal/master-proposal-line.service.ts